/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Live_Caption_Active_Event_GroupInputs */

const en_live_caption_active_event_group = /** @type {(inputs: Live_Caption_Active_Event_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Active Event Group`)
};

const fr_live_caption_active_event_group = /** @type {(inputs: Live_Caption_Active_Event_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Groupe d'événements actifs`)
};

const de_live_caption_active_event_group = /** @type {(inputs: Live_Caption_Active_Event_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktive Ereignisgruppe`)
};

const it_live_caption_active_event_group = /** @type {(inputs: Live_Caption_Active_Event_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gruppo eventi attivi`)
};

const ru_live_caption_active_event_group = /** @type {(inputs: Live_Caption_Active_Event_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Активная группа мероприятий`)
};

const es_live_caption_active_event_group = /** @type {(inputs: Live_Caption_Active_Event_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grupo de eventos activos`)
};

const zh_cn2_live_caption_active_event_group = /** @type {(inputs: Live_Caption_Active_Event_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`活跃事件组`)
};

const ja_live_caption_active_event_group = /** @type {(inputs: Live_Caption_Active_Event_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アクティブイベントグループ`)
};

const hi_live_caption_active_event_group = /** @type {(inputs: Live_Caption_Active_Event_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सक्रिय इवेंट समूह`)
};

const pt_pt2_live_caption_active_event_group = /** @type {(inputs: Live_Caption_Active_Event_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grupo de Eventos Ativos`)
};

/**
* | output |
* | --- |
* | "Active Event Group" |
*
* @param {Live_Caption_Active_Event_GroupInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const live_caption_active_event_group = /** @type {((inputs?: Live_Caption_Active_Event_GroupInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Live_Caption_Active_Event_GroupInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_live_caption_active_event_group(inputs)
	if (locale === "de") return de_live_caption_active_event_group(inputs)
	if (locale === "it") return it_live_caption_active_event_group(inputs)
	if (locale === "ru") return ru_live_caption_active_event_group(inputs)
	if (locale === "es") return es_live_caption_active_event_group(inputs)
	if (locale === "zh-CN") return zh_cn2_live_caption_active_event_group(inputs)
	if (locale === "ja") return ja_live_caption_active_event_group(inputs)
	if (locale === "hi") return hi_live_caption_active_event_group(inputs)
	if (locale === "pt-PT") return pt_pt2_live_caption_active_event_group(inputs)
	return en_live_caption_active_event_group(inputs)
});